"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CountryCodeValidationPlugin_1 = __importDefault(require("./plugins/CountryCodeValidationPlugin"));
var DateValidationPlugin_1 = __importDefault(require("./plugins/DateValidationPlugin"));
var EmailValidationPlugin_1 = __importDefault(require("./plugins/EmailValidationPlugin"));
var FileValidationPlugin_1 = __importDefault(require("./plugins/FileValidationPlugin"));
var NumberValidationPlugin_1 = __importDefault(require("./plugins/NumberValidationPlugin"));
var PatternValidationPlugin_1 = __importDefault(require("./plugins/PatternValidationPlugin"));
var RequiredValidationPlugin_1 = __importDefault(require("./plugins/RequiredValidationPlugin"));
var SubjectValidationPlugin_1 = __importDefault(require("./plugins/SubjectValidationPlugin"));
var TelephoneNumberValidationPlugin_1 = __importDefault(require("./plugins/TelephoneNumberValidationPlugin"));
var CatchAllValidationPlugin_1 = __importDefault(require("./plugins/CatchAllValidationPlugin"));
console.debug('INFO FieldValidator.ts loaded');
/**
 * @class
 */
var FieldValidator = /** @class */ (function () {
    function FieldValidator(field) {
        this.field = field;
        this.validationPlugins = [];
        this._processRequired();
        this._processNumber();
        this._processPattern();
        this._processFileUpload();
        this._processDate();
        this._processEmail();
        this._processSubject();
        this._processTelephoneNumber();
        // catch all validator: has to be last!
        if (this.field.getAttribute('type') !== 'checkbox') {
            this._addCatchAll();
        }
    }
    FieldValidator.prototype.runCustomValidations = function () {
        for (var _i = 0, _a = this.validationPlugins; _i < _a.length; _i++) {
            var plugin = _a[_i];
            plugin.runCustomValidation();
        }
    };
    FieldValidator.prototype.getMessages = function () {
        var messages = [];
        for (var _i = 0, _a = this.validationPlugins; _i < _a.length; _i++) {
            var plugin = _a[_i];
            if (!plugin.isValid()) {
                messages.push(plugin.getMessage());
            }
        }
        return messages;
    };
    FieldValidator.prototype._addValidationPlugin = function (plugin) {
        if (plugin) {
            this.validationPlugins.push(plugin);
        }
    };
    FieldValidator.prototype._processRequired = function () {
        if (this.field.hasAttribute('required')) {
            this._addValidationPlugin(new RequiredValidationPlugin_1.default(this.field));
        }
    };
    FieldValidator.prototype._processNumber = function () {
        if (this.field.getAttribute('type') === 'number') {
            this._addValidationPlugin(new NumberValidationPlugin_1.default(this.field));
        }
    };
    FieldValidator.prototype._processDate = function () {
        if (this.field.hasAttribute('date')) {
            this._addValidationPlugin(new DateValidationPlugin_1.default(this.field));
        }
    };
    FieldValidator.prototype._processEmail = function () {
        if (this.field.getAttribute('name') === 'email') {
            this._addValidationPlugin(new EmailValidationPlugin_1.default(this.field));
        }
    };
    FieldValidator.prototype._processPattern = function () {
        if (this.field.hasAttribute('pattern')) {
            this._addValidationPlugin(new PatternValidationPlugin_1.default(this.field));
        }
    };
    FieldValidator.prototype._processFileUpload = function () {
        if (this.field.getAttribute('type') === 'file') {
            this._addValidationPlugin(new FileValidationPlugin_1.default(this.field));
        }
    };
    FieldValidator.prototype._addCatchAll = function () {
        this._addValidationPlugin(new CatchAllValidationPlugin_1.default(this.field));
    };
    FieldValidator.prototype._processSubject = function () {
        if (this.field.getAttribute('id') === 'select-subject') {
            this._addValidationPlugin(new SubjectValidationPlugin_1.default(this.field));
        }
    };
    FieldValidator.prototype._processTelephoneNumber = function () {
        if (this.field.getAttribute('name') === 'telephonenumber') {
            var countryCodeField = document.querySelector('select[name="telephonenumber_countryCode"]');
            this._addValidationPlugin(new TelephoneNumberValidationPlugin_1.default(this.field, countryCodeField));
        }
        else if (this.field.getAttribute('name') === 'mobilenumber') {
            var countryCodeField = document.querySelector('select[name="mobilenumber_countryCode"]');
            this._addValidationPlugin(new TelephoneNumberValidationPlugin_1.default(this.field, countryCodeField));
        }
        else if (this.field.getAttribute('name') === 'telephonenumber_countryCode') {
            var telephoneNumberField = document.querySelector('input[name="telephonenumber"]');
            this._addValidationPlugin(new CountryCodeValidationPlugin_1.default(this.field, telephoneNumberField));
        }
        else if (this.field.getAttribute('name') === 'mobilenumber_countryCode') {
            var telephoneNumberField = document.querySelector('input[name="mobilenumber"]');
            this._addValidationPlugin(new CountryCodeValidationPlugin_1.default(this.field, telephoneNumberField));
        }
    };
    return FieldValidator;
}());
exports.default = FieldValidator;
